import { HourglassBottomRounded } from "@mui/icons-material";

export const hourglassBottom = (props) => {
  return <HourglassBottomRounded {...props} />;
};
